import React from "react";
import * as styles from "./Checkbox.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import CheckboxHelper from "@app/components/CheckboxHelper";
import * as checkboxStyles from "@app/components/Checkbox/Checkbox.module.scss";
import * as checkboxHelperStyles from "@app/components/CheckboxHelper/CheckboxHelper.module.scss";
import { Field, useField, useFormik, useFormikContext } from "formik";

const Checkbox = (props) => {
	const { id = "", name = "", label, disabled, isSwitch = false } = props;

	return (
		<CheckboxHelper {...props}>
			{(inputProps) => {
				const className = classNames({
					[styles.checkbox]: true,
					[styles["is-active"]]: inputProps.isActive,
					[styles["is-disabled"]]: disabled,
					[styles["is-switch"]]: isSwitch,
					[props.className]: !!props.className,
				});

				return (
					<label
						htmlFor={id || name}
						className={styles.wrapper + (props.className ? " " + props.className : "")}
					>
						<div className={className}>
							<span className={styles["checkbox-element"]} />
							<span className={styles["checkbox-label"]}>{label}</span>
						</div>
					</label>
				);
			}}
		</CheckboxHelper>
	);
};

Checkbox.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	defaultValue: PropTypes.any,
	hasError: PropTypes.bool,
	onChange: PropTypes.func,
	children: PropTypes.func,
	disabled: PropTypes.bool,
	isSwitch: PropTypes.bool,
};

export default Checkbox;

export const DefaultCheckBox = ({ name, value, label, useSingle, id, selected: externalSelected, ...props }) => {
	const [, { value: fieldArrayValue }] = useField(name);
	const selected = fieldArrayValue?.includes?.(value);
	const className = classNames({
		[checkboxStyles.checkbox]: true,
		[checkboxStyles["is-active"]]: externalSelected !== undefined ? externalSelected : selected,
		// [styles["is-disabled"]]: disabled,
		[props.className]: !!props.className,
	});

	const checkboxHelperClassName = classNames({
		[checkboxHelperStyles["checkbox-helper"]]: true,
	});

	return (
		<div className={checkboxHelperClassName}>
			<label htmlFor={id} className={checkboxStyles.wrapper + (props.className ? " " + props.className : "")}>
				<div className={className}>
					<span className={checkboxStyles["checkbox-element"]} />
					<span className={checkboxStyles["checkbox-label"]}>{label}</span>
				</div>
			</label>
			<Field type={!useSingle ? "checkbox" : "radio"} name={name} value={value} id={id} />
		</div>
	);
};
